import { AppConfig } from '../../../common/model/config';
import { onyoTheme } from '../themes/onyo.theme';
import { ORDER_TYPE_DELIVERY } from '../../../common/model/order-types';

export const onyoAppConfig: AppConfig = {
  appName: 'onyo',
  appTitle: 'App Onyo',
  appDescription: 'Peça aqui com a Onyo.',
  aggregator: 820,
  takeOutAggregatorId: 21,
  brand: 4,
  theme: onyoTheme,
  faviconPath: '/favicons/favicon-onyo.ico',
  defaultOrderType: ORDER_TYPE_DELIVERY,
  defaultLocation: {
    // Avenida Paulista
    latitude: -23.5631043,
    longitude: -46.6565712,
  },
  featureFlags: {
    embeddedApplication: false,
    getBrandThemeFromBackend: false,
    shuffleCompanyArray: false,
    gmapsAddress: true,
    showOptionsTabsAggregators: true,
    filterByDeliveryArea: true,
    useLocalAggregatorHeaderImg: true,
    localAggregatorImgPath: '/aggregator-headers/aggregator-header-onyo.png',
  },
};
